module.exports = __webpack_public_path__ + "/images/cover-cta-caja-verde.bc7519f.jpg";